export const formatEnumLabel = (value: string) =>
  value
    .toLocaleLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
